import { render, staticRenderFns } from "./WaveformChart.vue?vue&type=template&id=65857aa0&scoped=true&"
import script from "./WaveformChart.vue?vue&type=script&lang=js&"
export * from "./WaveformChart.vue?vue&type=script&lang=js&"
import style0 from "./WaveformChart.vue?vue&type=style&index=0&id=65857aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65857aa0",
  null
  
)

export default component.exports